
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";

interface CookieSettingsTabProps {
  id: string;
  title: string;
  description: string;
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
}

export function CookieSettingsTab({
  id,
  title,
  description,
  checked,
  onChange,
  disabled = false
}: CookieSettingsTabProps) {
  return (
    <div className="flex items-center justify-between space-x-2">
      <div>
        <Label htmlFor={id} className="font-medium">{title}</Label>
        <p className="text-sm text-muted-foreground">{description}</p>
      </div>
      <Switch 
        id={id} 
        checked={checked} 
        onCheckedChange={onChange} 
        disabled={disabled}
      />
    </div>
  );
}

export default CookieSettingsTab;
